
export default class paginationAccessibility
{
    constructor()
    {
    $(window).on('load', function(){
        setTimeout(() => {
            if (!$('ul.pagination').length) {
                return;
            }

            this.setAriaLabels();

            $('ul.pagination').on('click keydown', () => {
                this.setAriaLabels();
            });
        }, 1000);
    });
    }

    setAriaLabels()
    {
        $('ul.pagination a').each(function () {
            let $this = $(this);

            // add aria-selected
            if ($this.parent().hasClass('active')) {
                $this.attr('aria-current', 'true');
            } else {
                $this.attr('aria-current', 'false');
            }

            if (Number($this.text())) {
                $this.attr('aria-label', 'Page ' + $this.text());
            } else if ($this.text() === '…') {
                $this.attr('aria-label', 'Disabled Link');
            } else if ($this.text().includes('Next')) {
                $this.attr('aria-label', 'Next page');
            } else if ($this.text().includes('Previous')) {
                $this.attr('aria-label', 'Previous page');
            }
        });
    }
}
